export const imagesInUse = (images, selected) => images
  .filter(image => (selected.includes(image.id) && image.inUse));


export const containsImagesInUse = (images, selected) => imagesInUse(images, selected).length > 0;
